import gql from 'graphql-tag';

import cardTemplateDetails from '../../../../services/cards/graphql/fragments/cardTemplateDetails';

export const cardTemplateCreate = gql`
  mutation cardTemplateCreate($input: CardTemplateCreateInput!) {
    cardTemplateCreate(input: $input) {
      card_template {
        ...cardTemplateDetails
      }
    }
  }
  ${cardTemplateDetails}
`;

export const cardTemplateUpdate = gql`
  mutation cardTemplateUpdate($input: CardTemplateUpdateInput!) {
    cardTemplateUpdate(input: $input) {
      card_template {
        ...cardTemplateDetails
      }
    }
  }
  ${cardTemplateDetails}
`;
